/**
 * 디버깅 설정 상수
 * 각 모듈별로 디버깅 로그를 활성화/비활성화할 수 있습니다.
 */

export const DEBUG_CONFIG = {
  // 실제 매출 자동화 관련 디버깅
  ACTUAL_SALES: {
    // 전체 실제 매출 디버깅 (마스터 스위치)
    ENABLED: process.env.NODE_ENV === 'development' || process.env.REACT_APP_DEBUG_ACTUAL_SALES === 'true',
    
    // 세부 모듈별 디버깅 플래그
    HOOK: true,           // useActualSalesData 훅 디버깅
    SERVICE: true,        // ActualSalesService 서비스 디버깅
    UI: true,             // UI 렌더링 디버깅
    CACHE: true,          // 캐시 관련 디버깅
    FIREBASE: true,       // Firebase 데이터 로딩 디버깅
    CALCULATION: true,    // 계산 과정 디버깅
    ASSIST_DETAIL: true,  // 어시스트별 상세 데이터 디버깅
    TEAM_AGGREGATION: true, // 팀별 집계 디버깅
    
    // 성능 관련 디버깅
    PERFORMANCE: true,    // 성능 측정 디버깅
    TIMING: true,         // 시간 측정 디버깅
    
    // 데이터 유효성 검사
    VALIDATION: true,     // 데이터 유효성 검사 디버깅
    
    // 에러 처리
    ERROR_DETAILS: true   // 상세한 에러 정보 디버깅
  },
  
  // 기타 모듈별 디버깅 플래그 (향후 확장 가능)
  DAILY_REPORT: {
    ENABLED: process.env.REACT_APP_DEBUG_DAILY_REPORT === 'true'
  },
  
  TEAM_PERFORMANCE: {
    ENABLED: process.env.REACT_APP_DEBUG_TEAM_PERFORMANCE === 'true'
  }
};

/**
 * 디버깅 플래그 동적 제어를 위한 함수들
 */
export class DebugController {
  /**
   * 특정 모듈의 디버깅을 활성화/비활성화
   */
  static setActualSalesDebug(flag: keyof typeof DEBUG_CONFIG.ACTUAL_SALES, enabled: boolean) {
    if (flag !== 'ENABLED') {
      (DEBUG_CONFIG.ACTUAL_SALES as any)[flag] = enabled;
    }
  }
  
  /**
   * 모든 실제 매출 디버깅 활성화/비활성화
   */
  static setAllActualSalesDebug(enabled: boolean) {
    Object.keys(DEBUG_CONFIG.ACTUAL_SALES).forEach(key => {
      if (key !== 'ENABLED') {
        (DEBUG_CONFIG.ACTUAL_SALES as any)[key] = enabled;
      }
    });
  }
  
  /**
   * 현재 디버깅 설정 상태 확인
   */
  static getDebugStatus() {
    return {
      ACTUAL_SALES: DEBUG_CONFIG.ACTUAL_SALES,
      DAILY_REPORT: DEBUG_CONFIG.DAILY_REPORT,
      TEAM_PERFORMANCE: DEBUG_CONFIG.TEAM_PERFORMANCE
    };
  }
} 